const options:any = { year: 'numeric', month: 'long', day: 'numeric' };

/* Return date string in format dd/mm/yyy
** @param {Date} d - date to format, default to today
** @returns {string} date in dd/mm/yyyy format
*/
export function formatDMY(d:any) {
  // Default to today
  d = d || new Date();
  return ('0' + d.getDate()).slice(-2) + '/' +
         ('0' + (d.getMonth() + 1)).slice(-2) + '/' +
         ('000' + d.getFullYear()).slice(-4);
}

/* Return date string in format dd/mm/yyy */
export function getDMYFromTimestamp(timestampInSeconds:number) {


  const date = new Date(timestampInSeconds*1000);
  ;
  // var day = date.getDate();
  // var month = date.getMonth() + 1;
  // var year = date.getFullYear();
  // return day + "/" + month + "/" + year;
  return date.toLocaleDateString('es-CO', { year: 'numeric', month: '2-digit', day: '2-digit' });
}


export function getIntFormatFromTimestamp(timestampInSeconds:number) {
  const date = new Date(timestampInSeconds*1000);

 return  new Intl.DateTimeFormat('es', options).format(date);
}



// export const formatted_date = current_date.getDate() + "/" + current_date.getMonth() + 1 + "/" + current_date.getFullYear()
